import React from 'react';
import Grid from '@material-ui/core/Grid';
import ReadAll from './readAll';
import ContentTitle from "/components/contentTitle";
import { DesktopArticleCards, MobileArticleCards } from './articleCards';

export function DesktopArticleCardsSection(props) {
  const { items, contentTitle, color, routeName, paramsName, readAll } = props;
  return (
    items.popular.length > 0 ?
    <Grid container>
        <ContentTitle contentTitle={contentTitle} color={color} />
        <DesktopArticleCards items={items.popular} />
        <ReadAll items={items} routeName={routeName} paramsName={paramsName} readAll={readAll} color={color} />
    </Grid>
     :null
  );
}

export function MobileArticleCardsSection(props) {
    const { items, contentTitle, color, routeName, paramsName, readAll } = props;
    return (
      items.popular.length > 0 ?
      <Grid container>
          <ContentTitle contentTitle={contentTitle} color={color} />
          <MobileArticleCards items={items.popular} maxNum={3} />
          <ReadAll items={items} routeName={routeName} paramsName={paramsName} readAll={readAll} color={color} />
      </Grid>
       :null
    );
  }


